import { Component, Input, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../data.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-form-propiedades',
  templateUrl: './form-propiedades.component.html',
  styleUrls: ['./form-propiedades.component.css']
})
export class FormPropiedadesComponent {
  formularioForm: FormGroup; // Nombre ajustado como formularioForm
  token: string;
  @Input() id: string | null = null; 

  constructor(private data: DataService, private fb: FormBuilder, private router: Router) {
    // Definimos el formulario con FormBuilder
    this.formularioForm = this.fb.group({
      Nombre: [{value: '', disabled: false}, [Validators.required, Validators.minLength(3)], ],
      // si this.id es no null, el campo descripcion debe estar bloqueado 
      Descripcion: [{value: '', disabled: false}, [Validators.required, Validators.minLength(3)], ],
      
    });

    this.token = this.data.Token;

    console.log("&&&&&&&&&&&&&&&&&&& token &&&&&&&&&&&&&&&&&&");
    console.log(this.token);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['id']) {      
      console.log("&&&&&&&&&&&&&&&&&&& id cambiado &&&&&&&&&&&&&&&&&&");
      console.log(this.id); // Ahora este valor será el que se pase desde el componente padre
    }

    if(this.id!=null){
      this.data.ObtenerFormulario(this.id).subscribe(x => {
        console.log("&&&&&&&&&&&&&&&&&&& ObtenerFormulario &&&&&&&&&&&&&&&&&&");
        console.log(x);
        this.formularioForm.patchValue({
          Nombre: x.Definicion.title,
          Descripcion: x.Definicion.description
        });
        this.formularioForm.controls['Nombre'].disable();
        this.formularioForm.controls['Descripcion'].disable();
      })
    }



  }

  // Método para manejar el envío del formulario
  onSubmit() {
    if (this.formularioForm.valid) {
      console.log('Formulario enviado:', this.formularioForm.value);
      var valores = this.formularioForm.value;
      var Definicion={
        "title": valores.Nombre,
        "description": valores.Descripcion
      }
      this.data.GuardarFormulario(this.id, JSON.stringify(Definicion), null, null, null).subscribe(x => {
        //alert("Formulario guardado " );
        console.log("Formulario guardado");
        console.log(x);
        this.id = x.id;
        
        //ir a formulario/this.id
        
        this.router.navigate(['/formulario', this.id]);


    })
    } else {
      console.log('Formulario no válido');
    }
  }

  // Getter para los controles del formulario
  get controls() {
    return this.formularioForm.controls;
  }
}
